// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-app-bar[data-v-020e5d11] {\n  position: sticky;\n}\n.c-title[data-v-020e5d11] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.c-menu-button[data-v-020e5d11]:focus::before {\n  opacity: 0 !important;\n}\n.c-controls[data-v-020e5d11] {\n  margin-right: -4px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
